import { useEffect, useState } from "react";

interface CodeVerificationCooldown {
  active: boolean;
  remainingTime: number;
}

const INACTIVE_COOLDOWN = {
  active: false,
  remainingTime: 0,
} as const;

export const useCodeVerificationCooldown = (canResendAt: number | null) => {
  const [cooldown, setCooldown] =
    useState<CodeVerificationCooldown>(INACTIVE_COOLDOWN);

  useEffect(() => {
    const checkCooldown = () => {
      if (!canResendAt) {
        setCooldown(INACTIVE_COOLDOWN);
      } else {
        const now = Date.now();
        const remaining = Math.ceil((canResendAt - now) / 1000);

        if (remaining <= 0) {
          setCooldown(INACTIVE_COOLDOWN);
        } else {
          setCooldown({
            active: true,
            remainingTime: remaining,
          });
        }
      }
    };

    checkCooldown();

    const interval = setInterval(checkCooldown, 1000);

    return () => clearInterval(interval);
  }, [canResendAt]);

  return {
    cooldown,
  };
};
